"use strict";

var _inherits = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HackerManager = exports.Hacker = void 0;

var Endpoints_1 = require("../Endpoints");

var user_1 = require("../models/user");

var form_data_1 = __importDefault(require("form-data"));

var api_1 = require("../util/api");

var base_1 = require("./base");

var Hacker = /*#__PURE__*/function () {
  function Hacker(rest, data) {
    _classCallCheck(this, Hacker);

    this.rest = rest;
    this.patch(data);
  }

  _createClass(Hacker, [{
    key: "patch",
    value: function patch(data) {
      this.beginner = data.beginner;
      this.canShareInfo = data.canShareInfo;
      this.eduInfo = data.eduInfo;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.password = data.password;
      this.email = data.email;
      this.beginner = data.beginner;
      this.phoneNumber = data.phoneNumber;
      this.ethnicity = data.ethnicity;
      this.pronouns = data.pronouns;
      this.socials = data.socials;

      if (!data.username) {
        throw new Error('Hacker data is missing username');
      }

      this.username = data.username;
    }
  }, {
    key: "setBeginner",
    value: function setBeginner(beginner) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.edit({
                  beginner: beginner
                }, false);

              case 2:
                this.beginner = beginner;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setSharingInfo",
    value: function setSharingInfo(canShareInfo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.edit({
                  canShareInfo: canShareInfo
                }, false);

              case 2:
                this.canShareInfo = canShareInfo;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "setFirstName",
    value: function setFirstName(firstName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.edit({
                  firstName: firstName
                }, false);

              case 2:
                this.firstName = firstName;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setLastName",
    value: function setLastName(lastName) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.edit({
                  lastName: lastName
                }, false);

              case 2:
                this.lastName = lastName;

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "setPronouns",
    value: function setPronouns(pronouns) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.edit({
                  pronouns: pronouns
                }, false);

              case 2:
                this.pronouns = pronouns;

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "setEducationInfo",
    value: function setEducationInfo(eduInfo) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.edit({
                  eduInfo: eduInfo
                }, false);

              case 2:
                this.eduInfo = eduInfo;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "setPhoneNumber",
    value: function setPhoneNumber(phoneNumber) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.edit({
                  phoneNumber: phoneNumber
                }, false);

              case 2:
                this.phoneNumber = phoneNumber;

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "setEthnicity",
    value: function setEthnicity(ethnicity) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.edit({
                  ethnicity: ethnicity
                }, false);

              case 2:
                this.ethnicity = ethnicity;

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "setSocials",
    value: function setSocials(socials) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.edit({
                  socials: socials
                }, false);

              case 2:
                this.socials = socials;

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "getResume",
    value: function getResume() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.hackerResume(this.username)).catch(api_1.entityNotFoundHandler);

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
    /**
     * Performs a bulk edit of this event.
     * @param data The data to edit.
     * @param refetch Whether or not to refetch the updated resource.
     */

  }, {
    key: "edit",
    value: function edit(data) {
      var refetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var transformedData, newData;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (this.username) {
                  _context11.next = 2;
                  break;
                }

                throw new Error('Invalid User');

              case 2:
                transformedData = (0, user_1.transformHacker)(data);
                _context11.next = 5;
                return this.rest.performRequest(Endpoints_1.Endpoints.specificHacker(this.username), {
                  method: 'PUT',
                  body: JSON.stringify(transformedData),
                  headers: {
                    'Content-Type': 'application/json'
                  }
                });

              case 5:
                if (!refetch) {
                  _context11.next = 10;
                  break;
                }

                _context11.next = 8;
                return this.rest.performRequest(Endpoints_1.Endpoints.specificHacker(this.username));

              case 8:
                newData = _context11.sent;
                this.patch(newData);

              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }]);

  return Hacker;
}();

exports.Hacker = Hacker;

var HackerManager = /*#__PURE__*/function (_base_1$BaseManager) {
  _inherits(HackerManager, _base_1$BaseManager);

  var _super = _createSuper(HackerManager);

  function HackerManager() {
    _classCallCheck(this, HackerManager);

    return _super.apply(this, arguments);
  }

  _createClass(HackerManager, [{
    key: "create",
    value:
    /**
     * Create a new hacker.
     * @param hacker The hacker data to upload.
     * @param resume The bugger of the resume file data.
     */
    function create(hacker, resume) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var hackerPayload, formData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                hackerPayload = JSON.stringify((0, user_1.transformHacker)(hacker));
                formData = new form_data_1.default(); // Add hacker entry.

                formData.append('hacker', hackerPayload);

                if (resume) {
                  formData.append('resume', resume);
                }

                _context12.next = 6;
                return this.rest.performRequest(Endpoints_1.Endpoints.createHacker, {
                  method: 'POST',
                  body: formData
                });

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "fetch",
    value: function fetch(username) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var data, hackerData;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.specificHacker(username)).catch(api_1.entityNotFoundHandler);

              case 2:
                data = _context13.sent;

                if (!(!data || !data['Hacker Profile'])) {
                  _context13.next = 5;
                  break;
                }

                return _context13.abrupt("return", undefined);

              case 5:
                hackerData = (0, user_1.transformAPIHacker)(data['Hacker Profile']);
                return _context13.abrupt("return", new Hacker(this.rest, hackerData));

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
    /**
     * Gets all of the registered hackers.
     * @returns All of the registered hackers.
     */

  }, {
    key: "fetchAll",
    value: function fetchAll() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var response;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.rest.performRequest(Endpoints_1.Endpoints.allHackers).catch(api_1.emptyCollectionHandler);

              case 2:
                response = _context14.sent;
                return _context14.abrupt("return", response.hackers.map(user_1.transformAPIHacker));

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }]);

  return HackerManager;
}(base_1.BaseManager);

exports.HackerManager = HackerManager;